export const environment = {
  production: true,
  APP_KEY: 'ff14205f-5a71-4c1a-9893-811b6158f5f9',
  apiEndpoint: 'https://api.pr.sebrae.com.br/polo-lideranca-api',
  BASE_STORAGE_URL: 'https://app2.pr.sebrae.com.br/storage/pololideranca/',
  AREA_LOGADA_OLD: 'https://app2.pr.sebrae.com.br/polo-lideranca-ng2/'
};
